import { isBrowser } from "./isBrowser";

export const hideNavigationItem = (hideParams: Record<string, string> | undefined, queryParams: any) => {
  if (!hideParams) return false;

  return Object.entries(hideParams).some(([key, val]) => {
    const queryValue = queryParams.get(key);

    if (queryValue === val) {
      if (isBrowser() && !sessionStorage.getItem(key)) {
        sessionStorage.setItem(key, val);
      }

      return true;
    }

    if (isBrowser() && sessionStorage.getItem(key) === val) {
      return true;
    }

    return false;
  });
};
